export default "__VITE_ASSET__DMfI6kRz__"